<template>
  <div>
    <v-row v-if="user">
      <v-col>
        <AvatarWithBadge :user="user" />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col v-if="user.userProfile && user.userProfile.username">
        @{{ user.userProfile.username }}</v-col
      >
    </v-row>
    <v-divider class="my-5"></v-divider>
    <v-row no-gutters>
      <v-col>
        <v-list dense nav class="pa-0">
          <v-list-item v-for="link in links" :key="link.href" :to="{ name: link.routeName }" class="rounded-0 text-left">
            <v-list-item-icon>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{
                link.text
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
import AvatarWithBadge from '@/components/User/AvatarWithBadge.vue';
export default {
  mixins: [hasLoggedInUser],
  name: "CreatorToolsSidebar",
  components: {
    AvatarWithBadge,
  },
  computed: {
    links() {
      return [
        {
          routeName: "admin-users",
          text: this.$t("admin.users.users"),
          icon: 'mdi-account-circle'
        },
        {
          routeName: "admin-stories",
          text: this.$t("admin.stories.stories"),
          icon: 'mdi-book-open'
        },
        {
          routeName: "admin-review-stories",
          text: this.$t("admin.reviewStories"),
          icon: 'mdi-message-draw'
        },
      ]
    },
  }
}
</script>
